import { useNotifier } from '@provider/notifier';
import { IconButton } from '@ui/kit';
import { TrashIcon } from '@ui/kit/icons';
import { jsx } from 'react/jsx-runtime';
import { useDeleteCourseMutation } from '../../api/mutation.delete.js';

function DeleteAction({
  course,
  closeDropdown
}) {
  const notifier = useNotifier();
  const {
    mutate
  } = useDeleteCourseMutation();
  return /*#__PURE__*/jsx(IconButton, {
    icon: /*#__PURE__*/jsx(TrashIcon, {}),
    label: "Slet forl\xF8b",
    visibleLabel: true,
    onClick: async () => {
      closeDropdown();
      const confirmed = await notifier.confirm({
        heading: "Vil du slette forløbet?",
        body: "Bemærk at denne handling ikke kan fortrydes. Hvis du sletter et forløb, der allerede er delt, vil forløbet ikke længere være tilgængeligt for modtageren.",
        labels: {
          ok: "Slet"
        }
      });
      if (confirmed !== "ok") {
        return;
      }

      // Optimistically delete course, we assume it is going to succeed. Error
      // handling will be performed using notificationCenter.
      mutate(course);
    }
  });
}

export { DeleteAction };
//# sourceMappingURL=actions.delete.js.map
